import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Savings to Reach Goal</h1>
        <iframe src="https://www.financialcalculators.net/librocu/savings-goal/" title="Savings to Reach Goal" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize />
    </div>
);
